<app-modal *ngIf="vo$ | async; let vo">
	<app-exposition-endpoint-metadata-config
		modal-body
		[expositionId]="vo.expositionId"
		[expositionMetadata]="vo.metadata"
		[isInViewMode]="false"
		(hasEndPointMetadataChanged)="
			checkValidity()
		"></app-exposition-endpoint-metadata-config>

	<div modal-footer class="app-expositions-metadata-popover__footer">
		<button
			*ngIf="vo.canEdit"
			id="{{ cmpId }}-save-btn"
			color="primary"
			mat-raised-button
			[disabled]="!vo.isValid"
			(click)="save()">
			<span i18n="@@general.action.save">save</span>
		</button>
	</div>
</app-modal>
